module.exports = __webpack_public_path__ + "media/venue/webinars@1x-a74a11a4.png";